import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgForOf, NgIf } from '@angular/common';

export type TsAutocompleteOptionsGroup = { group: string; options: string[] }[];

export function isTsAutoCompleteOptionsGroup(value: any): value is TsAutocompleteOptionsGroup {
  return (
    Array.isArray(value) &&
    value.every(
      (v) => Object.prototype.hasOwnProperty.call(v, 'group') && Object.prototype.hasOwnProperty.call(v, 'options'),
    )
  );
}

@Component({
  selector: 'ts-autocomplete',
  templateUrl: './ts-autocomplete.component.html',
  styleUrls: ['./ts-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatOptionModule, MatAutocompleteModule, NgForOf, NgIf],
  standalone: true,
})
export class TsAutocompleteComponent {
  @Input() set options(value: string[] | TsAutocompleteOptionsGroup) {
    this.isGroupOption = isTsAutoCompleteOptionsGroup(value);
    this._options = value;
  }

  @Output() closed = new EventEmitter<void>();

  // Static so ts-input can bind it on its first render: <mat-autocomplete> is unconditional in this template.
  @ViewChild(MatAutocomplete, { static: true }) autocomplete: MatAutocomplete;

  isGroupOption = false;
  _options: string[] | TsAutocompleteOptionsGroup;

  static filterGroupOptions(value: string, options: TsAutocompleteOptionsGroup): TsAutocompleteOptionsGroup {
    return options
      .map(({ group, options }) => {
        return {
          group,
          options: TsAutocompleteComponent.filterOptions(value, options),
        };
      })
      .filter(({ options }) => options.length > 0);
  }

  static filterOptions(value: string, options: string[]): string[] {
    return options.filter((option) => option.toLowerCase().includes(value.toLowerCase()));
  }
}
